<h2 mat-dialog-title>Confirmation d'importation</h2>
<mat-dialog-content>
<div class="panel panel-default ">
	  <div [ngClass]="" class="panel-body">
      Veuillez confirmer l'importation de tous les messages
    </div>
</div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close class="btn btn-danger">Annuler</button>
    <button mat-button mat-dialog-close class="btn btn-success" (click)="startImport()">Confirmer</button>
</mat-dialog-actions>